import React from 'react'
import HelloSign from 'hellosign-embedded'
import axios from 'axios'

const client = new HelloSign();

class EmbeddedSigning extends React.Component {
  state = {
    loaded: false,
    signUrl: '',
    clientId: ''
  }

  ///////////////////////////////////////////////
  // Lifecycle
  ///////////////////////////////////////////////

  componentDidMount() {
    axios.post(window.location.href, {}, {
      headers: {
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]')?.getAttribute('content')
      }
    }).then(response => {
      this.setState({
        loaded: true,
        signUrl: response.data.sign_url,
        clientId: response.data.client_id
      })
    }).catch(error => {
      console.error("Error fetching signing URL:", error);
      window.location = this.props.redirect_to
    })
  }

  render() {
    if(this.state.loaded) {
      client.open(this.state.signUrl, {
        clientId: this.state.clientId,
        testMode: this.props.test_mode,
        debug: this.props.test_mode,
        allowCancel: false,
        hideHeader: true,
        redirectTo: this.props.redirect_to,
        container: document.getElementById('hellosign-mount'),
        // White labeling documentation
        // https://developers.hellosign.com/api/reference/premium-branding/
        whiteLabeling: {
          page_background_color: '#FFFFFF',
          header_background_color: '#F6F8FC',
          primary_button_color: '#3E3E9D',
          text_color2: '#3E3E9D'
        }
      })

      client.on('sign', (data) => {
        console.log(`The signature request was signed!`, data);
        axios.patch(window.location.href, data, {
          headers: {
            'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]')?.getAttribute('content')
          }
        }).then(response => {
          console.log("success!", response);
          window.location = this.props.redirect_to
        }).catch(error => {
          console.error("Error completing signature:", error);
          window.location = this.props.redirect_to
        })
      })

      client.on('ready', (data) => {
        setTimeout(function(){ Spinner.complete(); }, 1000);
      })
    }
    return (
      <React.Fragment>
      </React.Fragment>
    )
  }
}

export default EmbeddedSigning
